<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div class="d-flex justify-content-around mb-3">
            <div style="flex: 1; padding-left: 20px;">
                <div>
                    <div style="font-size: 20px; font-weight: bold;">{{ getLangValue("hscode.name") }}</div>
                    <div style="color: #878A99;">{{ getLangValue("hscode.description") }}</div>
                </div>
            </div>
            <div class="d-flex justify-content-end" style="flex: 1; align-items: center;">
                <div class="w-10 mx-2" v-show="showIndex == 0">
                    <el-select v-model="type" placeholder=" " size="mini" style="width: 200px; height: 37.5px;"
                        @change="changeType">
                        <el-option v-for="item in treeData" :key="item.id"
                            :label="i18n.global.locale == 'en' ? item.title_en : item.title" :value="item.id" />
                    </el-select>
                </div>
                <div class="w-10 mx-2">
                    <input type="text" class="form-control" v-model="filterText" @blur="handleSearch"
                        :placeholder="getLangValue('hscode.searchPlaceholder')" />
                </div>
                <button v-permit="'hscode.add'" type="button" class="btn btn-success me-3" @click="addClick()"
                    style="min-width: 140px;">
                    <i class="ri-add-fill me-1 align-bottom"></i>
                    {{ getLangValue("hscode.add") }}
                </button>

                <i class="ri-layout-grid-fill me-1 align-bottom mx-2" v-show="showIndex == 1"
                    :style="showIndex == 0 ? ActivebuttonStyle : buttonStyle" @click="handleshowIndex(0)"></i>
                <i class="ri-list-unordered me-1 align-bottom mx-2" v-show="showIndex == 0"
                    :style="showIndex == 1 ? ActivebuttonStyle : buttonStyle" @click="handleshowIndex(1)"></i>
            </div>
        </div>
        <div class="hscode">
            <div class="p-2" v-loading="loadingTree" style="height: 100%;">
                <div v-show="showIndex == 0" style="height: 100%;">
                    <chart ref="chartRefs" :typeList="treeData" @updateTreeData="getTreeList"
                        @updateChartData="updateChartData" />
                </div>
                <div v-show="showIndex == 1" class="hscode-container">
                    <div class="tree-content">
                        <div class="leftMenu card ">
                            <div class="w-100"
                                style="background-color: #E2E8ED; height: 40px; line-height: 40px; padding-left: 20px;font-size: 16px;">
                                {{ getLangValue("hscode.name") }}</div>
                            <!-- <div class="search-box me-3">
                                <input type="text" class="form-control searchInput"
                                    :placeholder="getLangValue('hscode.filterHscode')" v-model="filterText" />
                            </div> -->
                            <!-- 树形结构 -->
                            <div style="height: calc(100% - 40px);" class="overflow-auto my-scroll-bar">
                                <LeftMenu v-if="filterTreeData.length" :treeList="filterTreeData"
                                    :selected="selectedObj.id" @getUserDetail="getUserDetail" @sortTree="sortTree"
                                    :fatherIdList1="fatherIdList"></LeftMenu>
                            </div>
                        </div>
                    </div>
                    <div class="hscode-content">
                        <div class="card mb-2">
                            <div class="card-body" style="padding: 0 20px;">
                                <div class="d-flex justify-content-between " style="padding: 10px 0;">
                                    <!-- <div class="title">{{ selectedObj.label }}</div> -->
                                    <div class="title">{{ i18n.global.locale == 'en' ? selectedObj.title_en :
                                        selectedObj.title }}</div>

                                    <div class="d-flex justify-content-end">
                                        <b-button class="mx-2" v-permit="'hscode.copy'"
                                            style="background-color: #0AB39C;color:white" variant=""
                                            v-b-toggle.searchCollapse1.searchCollapse2 @click="copyHsCode">
                                            <i class=" ri-file-copy-2-line me-1 align-bottom"></i>
                                            {{ getLangValue("base.copy") }}
                                        </b-button>
                                        <b-button v-permit="'hscode.modify'"
                                            style="background-color: #0AB39C;color:white" variant=""
                                            v-b-toggle.searchCollapse1.searchCollapse2 @click="editHsCode" class="mx-2">
                                            <i class="ri-edit-fill me-1 align-bottom"></i>
                                            {{ getLangValue("base.edit") }}
                                        </b-button>
                                        <b-button class="mx-2" v-permit="'hscode.delete'"
                                            style="background-color: #F06547;color:white" variant=""
                                            v-b-toggle.searchCollapse1.searchCollapse2 @click="deleteHsCode">
                                            <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                                            {{ getLangValue("base.delete") }}
                                        </b-button>
                                    </div>
                                </div>
                                <div class="basic-info ">
                                    <div class="w-100 my-4 " style="font-size: 16px; border-bottom: 1px solid #E9EBEC;">
                                        {{ getLangValue('attribute.base') }}
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div class="col-3">
                                            <label for="weight-field" class="form-label">
                                                <span>{{ getLangValue("hscode.encodingId") }}:</span>
                                            </label>
                                            <div style="height: 40px;font-weight: 400;">
                                                {{ selectedObj.hscode_id }}
                                            </div>
                                        </div>
                                        <div class="col-3" v-if="selectedObj.code">
                                            <label for="weight-field" class="form-label">
                                                <span>{{ getLangValue("hscode.productCode") }}:</span>
                                            </label>
                                            <div style="height: 40px;font-weight: 400;">
                                                {{ selectedObj.code }}
                                            </div>
                                        </div>

                                        <div class="col-3">
                                            <label for="weight-field" class="form-label">
                                                <span>{{ getLangValue("attribute.create_time") }}:</span>
                                            </label>
                                            <div style="height: 40px;font-weight: 400;">
                                                {{ dateFormat1(selectedObj.create_time) || "-" }}
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <label for="weight-field" class="form-label">
                                                <span>{{ getLangValue("attribute.last_time") }}:</span>
                                            </label>
                                            <div style="height: 40px;font-weight: 400;">
                                                {{ dateFormat1(selectedObj.update_time) || "-" }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-100">
                                        <label for="weight-field" class="form-label">
                                            <span>{{ getLangValue("attribute.description") }}:</span>
                                        </label>
                                        <div style="min-height: 40px; font-weight: 400;word-wrap: break-word;">
                                            {{ i18n.global.locale == 'en' ? selectedObj.description_en :
                                                selectedObj.description }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="group-tabs card "
                            v-if="selectedObj.index_standards && Object.keys(selectedObj.index_standards).length">
                            <div class="card-body py-0 d-flex flex-column" style="height: 100%">
                                <!-- tab栏 -->
                                <div v-if="groupList1.length" style="max-height: 115.5px;">
                                    <div class="table_tab mb-0">
                                        <!-- <ul class="nav nav-tabs nav-tabs-custom nav-success py-0" role="tablist"
                                            style="border-bottom: 1px solid #E9EBEC;">
                                            <li class="nav-item" v-for="(tab, i) in groupList1" :key="i">
                                                <a :class="[
                                                    'nav-link',
                                                    'All',
                                                    'py-2',
                                                    'position-relative cursor',
                                                    tab.id == current_tab && 'active',
                                                ]" @click="handlerToggleTab(tab.id)">{{ tab.name }}</a>
                                            </li>
                                        </ul> -->
                                        <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList1"
                                            v-model:current_tab="current_tab1" :tabKey="'group1'" />
                                        <!-- <ul class="nav nav-tabs nav-tabs-custom nav-success py-0" role="tablist"
                                            style="border-bottom: 1px solid #E9EBEC;">
                                            <li class="nav-item" v-for="(tab, i) in groupList2" :key="i">
                                                <a :class="[
                                                    'nav-link',
                                                    'All',
                                                    'py-2',
                                                    'position-relative cursor',
                                                    tab.id == current_tab && 'active',
                                                ]" @click="handlerToggleTab(tab.id)">{{ tab.name }}</a>
                                            </li>
                                        </ul> -->
                                        <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList2"
                                            v-model:current_tab="current_tab2" :tabKey="'group2'" />
                                        <!-- <ul class="nav nav-tabs nav-tabs-custom nav-success py-0" role="tablist"
                                            style="border-bottom: 1px solid #E9EBEC;">
                                            <li class="nav-item" v-for="(tab, i) in groupList3" :key="i">
                                                <a :class="[
                                                    'nav-link',
                                                    'All',
                                                    'py-2',
                                                    'position-relative cursor',
                                                    tab.id == current_tab && 'active',
                                                ]" @click="handlerToggleTab(tab.id)">{{ tab.name }}</a>
                                            </li>
                                        </ul> -->
                                        <swiperTab @onActiveTabId="onActiveTabId" :groupList="groupList3"
                                            v-model:current_tab="current_tab3" :tabKey="'group3'" />
                                    </div>
                                </div>
                                <!-- 展示表格信息 -->
                                <!-- style="height: calc(100% - 51.5px - 1.5rem);" -->
                                <div v-if="selectedObj.index_standards[current_tab]" style="flex: 1;overflow-y: auto;"
                                    class="my-scroll-bar">
                                    <div>
                                        <div class="d-flex"
                                            style="border-bottom: 1px solid #E9EBEC;background-color: #F3F6F9;">
                                            <div
                                                style="flex:2; min-height: 40px; line-height: 40px;;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{
                                                    getLangValue('hscode.indicatorName') }}</div>
                                            <!-- <div style="flex:1; height: 40px; line-height: 40px;background-color: #E9EBEC;">{{
                                            getLangValue('attribute.defaultvalue') }}</div> -->
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('attribute.unit') }}
                                            </div>
                                            <div
                                                style="flex:2; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC">
                                                {{
                                                    getLangValue('attribute.reference') }}</div>
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('hscode.threshold') }}</div>
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('hscode.standard_judgment_method') }}</div>
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('hscode.is_it_applicable') }}
                                            </div>
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('hscode.is_special_indicator')
                                                }}</div>
                                            <div
                                                style="flex:1; min-height: 40px; line-height: 40px;padding-left: 10px;border-right: 1px solid #E9EBEC;">
                                                {{ getLangValue('hscode.calculation_mode')
                                                }}</div>
                                        </div>
                                        <div class="py-1">
                                            <div class="d-flex" v-for="(item, k) in pageData" :key="k">
                                                <div
                                                    style="flex:2; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;word-break: break-all;">
                                                    {{ i18n.global.locale == 'en' ? item.name_en : item.name }}
                                                </div>
                                                <!-- <div style="flex:1; min-height: 40px; line-height: 40px;border: 1px solid #E9EBEC;padding-left: 10px;">{{ item.value }}
                                            </div> -->
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;word-break: break-all;">
                                                    {{ i18n.global.locale == 'en' ? item.unit_en : item.unit }}
                                                </div>
                                                <div
                                                    style="flex:2; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;word-break: break-all;">
                                                    {{ i18n.global.locale == 'en' ? item.reference_en : item.reference
                                                    }}</div>
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;word-break: break-all;">
                                                    {{ item.threshold }}
                                                </div>
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                                    {{ item.judgement_model == '[]' ? '∈' : item.judgement_model }}
                                                </div>
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                                    {{ item.is_applicable ? getLangValue('hscode.type.yes') :
                                                        getLangValue('hscode.type.no') }}
                                                </div>
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                                    {{ item.is_specific ? getLangValue('hscode.type.yes') :
                                                        getLangValue('hscode.type.no') }}
                                                </div>
                                                <div
                                                    style="flex:1; min-height: 40px; line-height: 40px;border-bottom: 1px solid #E9EBEC;border-right: 1px solid #E9EBEC;padding-left: 10px;">
                                                    {{ item.calculation_mode }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="height: 51px;"
                                    v-if="selectedObj.index_standards && Object.keys(selectedObj.index_standards).length">
                                    <Pagination v-if="selectedObj.index_standards[current_tab].total"
                                        v-model:page="pageNation[current_tab].currentPage"
                                        v-model:perPage="pageNation[current_tab].pageSize"
                                        :prePageOption="[10, 20, 30, 40, 50]"
                                        :pages="selectedObj.index_standards[current_tab].pageOption"
                                        :tab_info_length="selectedObj.index_standards[current_tab].total"
                                        class="me-5 mt-0" style="margin-top: 0 !important;">
                                    </Pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
    </Layout>
</template>

<script setup>
import i18n from "@/i18n"
import { ref, onMounted, nextTick, watch, provide, computed } from "vue";
const PageHeaderT = getLangValue("hscode.title");
import { dateFormat1, getIdList, filterTreeData1, getId } from "@/utils/common.js";
import chart from "./components/chart";
import router from "@/router";
import { useRoute } from "vue-router"
import Swal from "sweetalert2";
import LeftMenu from "./components/LeftMenu.vue";
import { deleteHscode, getHscode, getHscodeDetail, copyHscode, postHscode_management_index } from "@/service"
import { findParent } from "@/utils/common"
import _ from "lodash";
import { treeToFlat, treeToFlat1 } from "@/utils/common"
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import swiperTab from "../../components/common/swiperTab.vue";
import { getLangValue } from "@/utils/common"; //获取后端语言
const { alertInfo, openAlert, formValidataAlert } = useMessage()
provide('openAlert', openAlert)
const PageHeaderItems = [
    {
        text: getLangValue("hscode.title"),
        active: true,
        href: "/hscode_management",
    },
]
const route = useRoute()
const fatherIdList = ref([]) // 存储选中项的信息   包含父级  以方便展开父级
const loadingTree = ref(false) // tree加载
const chartRefs = ref(null) //图表
const selectedObj = ref({}) //选中的tree节点数据
const type = ref("") // 图表内父级类型切换
const filterTreeData = ref([]) //存储筛选后的数据  用于上方输入框筛选
const ActivebuttonStyle = { 'font-size': '1.5rem', cursor: 'pointer', color: 'blue' };
const buttonStyle = { 'font-size': '1.5rem', cursor: 'pointer' };
const showIndex = ref(1)
const filterText = ref("") //筛选字符串
const treeData = ref([]) //原始tree数据
// const treeData1 = ref([]) //原始tree数据  没有目的市场的
const pageData = ref([]) //存储指标信息自定义分页数据
const current_tab = ref('group_0') //总的索引
const current_tab1 = ref('') // 1级索引
const current_tab2 = ref('') //2级索引
const current_tab3 = ref('') //3级索引
const groupList = ref({}) // 所有的tab
const groupList1 = ref([]) // 1级tab
const groupList2 = ref([]) // 2级tab
const groupList3 = ref([]) // 3级tab
/* 切换tab展示内容 */
// const handlerToggleTab = (index) => {
//     if (current_tab.value == index) {
//         return;
//     }
//     // console.log(index);
//     current_tab.value = index;
//     // console.log(selectedObj.value);
//     pageData.value = selectedObj.value.index_standards[current_tab.value].pageData;
// }

watch(current_tab, (val) => {
    // 监听变化则切换tab
    changTab()
    pageData.value = Object.keys(selectedObj.value.index_standards).length ? selectedObj.value.index_standards[val].pageData : [];
})

const pageNation = ref({}) //存储指标信息分页的信息  当前页  分页size
const pageNationStr = ref(computed(() => JSON.stringify(pageNation.value)));
const handleIndicatorCurrentChange = (index) => {
    //当前tab 分页数据改变  获取当前页的数据
    // console.log(index);
    if (Object.keys(selectedObj.value.index_standards).length && Object.keys(pageNation.value).length) {
        //手动去切换分页数据
        // 设置分页
        // console.log(selectedObj.value.index_standards);
        // console.log(selectedObj.value.index_standards[index]);
        const { indicatorList } = selectedObj.value.index_standards[index];
        const { currentPage, pageSize } = pageNation.value[index];
        selectedObj.value.index_standards[index].pageOption = setPageOption(indicatorList, pageSize)
        let startIndex = ((currentPage - 1) * pageSize) - 1 < 0 ? 0 : ((currentPage - 1) * pageSize);
        let endIndex = startIndex + pageSize;
        pageData.value = selectedObj.value.index_standards[index].indicatorList.slice(startIndex, endIndex)
    } else {
        pageData.value = [];
    }

}

const changTab = () => {
    // 根据current_tab 设置子集信息
    // console.log(current_tab.value);
    let arr = current_tab.value.split('_');
    if (arr.length == 2) {
        // 代表第一级  需要联动第二级  第三级
        // 第二级
        groupList2.value = groupList.value.groupList2.filter(item => item.id.includes(current_tab.value));
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab2.value = ''
        current_tab3.value = ''
    } else if (arr.length == 3) {
        // 代表第二级  需要联动第三级
        // 第三级
        groupList3.value = groupList.value.groupList3.filter(item => item.id.includes(current_tab.value));
        current_tab3.value = ''
    }
}

const handleSearch = () => {
    let val = filterText.value
    if (showIndex.value == 1) {
        if (val) {
            //有值才筛选
            let newArr = getIdList(treeData.value, val, newArr);
            filterTreeData.value = [...newArr]
        } else {
            //无值直接使用原始数据 
            filterTreeData.value = [...treeData.value];
        }
        if (filterTreeData.value.length)
            handleNodeClick(filterTreeData.value[0].id);
    } else {
        //筛选图表
        loadingTree.value = true
        let arr = treeData.value.filter(tree => tree.id === type.value);
        if (val) {
            //有值才筛选  并带上父级
            let newArr = filterTreeData1(arr[0].children, val)
            const data = treeToFlat(newArr, 'parentId')
            chartRefs.value.initCharts(data, val)
            loadingTree.value = false
            // console.log(newArr);
        } else {
            const data = treeToFlat(arr, 'parentId')
            chartRefs.value.initCharts(data, val)
            loadingTree.value = false
        }

    }
}

// watch(filterText, (val) => {
//     //筛选字符串改变  筛选tree数据
//     if (showIndex.value == 1) {
//         if (val) {
//             //有值才筛选
//             let newArr = getIdList(treeData.value, val, newArr);
//             filterTreeData.value = [...newArr]
//         } else {
//             //无值直接使用原始数据 
//             filterTreeData.value = [...treeData.value];
//         }
//         if (filterTreeData.value.length)
//             handleNodeClick(filterTreeData.value[0].id);
//     } else {
//         //筛选图表
//         let arr = treeData.value.filter(tree => tree.id === type.value);
//         if (val) {
//             //有值才筛选  并带上父级
//             let newArr = filterTreeData1(arr[0].children, val)
//             const data = treeToFlat(newArr, 'parentId')
//             chartRefs.value.initCharts(data, val)
//             // console.log(newArr);
//         } else {
//             const data = treeToFlat(arr, 'parentId')
//             chartRefs.value.initCharts(data, val)
//         }

//     }
// })

const addClick = () => {
    //新增跳转
    let url = router.resolve({ path: '/hscode_management_detail', query: { type: 'add', showIndex: showIndex.value }, }).href
    window.open(url, '_blank')
}


/* 设置层级字段 */
const setValue = (childs, num) => {
    let children = _.cloneDeep(childs);
    children.forEach((child) => {
        child.num = num + 1;
        if (child.children && child.children.length) {
            child.children = setValue(child.children, child.num);
        }
    });
    return children;
}

const handleshowIndex = (index) => {
    //显示信息切换
    showIndex.value = index
    if (index == 0) {
        //更新图表 
        nextTick(() => {
            if (chartRefs.value.myChart)
                chartRefs.value.myChart.resize();
        })
    }
}

const getUserDetail = (id) => {
    handleNodeClick(id)
}
const setPageOption = (indicatorList, size) => {
    //设置分页信息
    let pageOption = []
    let numberOfPages = Math.ceil(indicatorList.length / size);
    for (let index = 1; index <= numberOfPages; index++) {
        pageOption.push(index);
    }
    return pageOption;
}
// watch(pageNation, () => {
//     // console.log(old);
//     // console.log(newVal);
//     //分页信息改变 分页数据切换
//     handleIndicatorCurrentChange(current_tab.value)
// }, { deep: true, })

watch(pageNationStr, (newVal, oldVal) => {
    // 监听分页切换
    let newObj = JSON.parse(newVal);
    let oldObj = JSON.parse(oldVal);
    // console.log(oldObj);
    for (const item in newObj) {
        if (oldObj[item] && newObj[item] !== oldObj[item]) {
            const { pageSize } = newObj[item]
            const { pageSize: pageSize1 } = oldObj[item]
            // console.log(pageSize);
            // console.log(pageSize1);
            if (pageSize !== pageSize1) {
                // pageSize 发生改变
                // console.log(11111111);
                pageNation.value[current_tab.value].currentPage = 1
            }
        }
    }
    handleIndicatorCurrentChange(current_tab.value)
})


watch(route, (val) => {
    //路由改变 已取消
    showIndex.value = val.query.showIndex;
    if (val.query.id) {
        // 获取父级id
        let arr = []
        findParent(treeData.value, route.query.id, arr)
        fatherIdList.value = [...arr]
        // console.log(fatherIdList.value)
        handleNodeClick(route.query.id);
    }
})
const handleNodeClick = async (id) => {
    // 树节点选中 去查询详情信息
    loadingTree.value = true
    const resp = await getHscodeDetail(id);
    loadingTree.value = false
    if (resp.payload !== null) {
        let index_standards_list = {}
        selectedObj.value = resp.payload;
        groupList1.value = []
        groupList2.value = []
        groupList3.value = []
        if (resp.payload.index_standards !== null) {
            for (let k in resp.payload.index_standards) {
                //在这里处理多层数据 用不同的key
                const { children, group_name, group_name_en, index_standards } = resp.payload.index_standards[k]
                groupList1.value.push({
                    name: i18n.global.locale == 'en' ? group_name_en : group_name,
                    id: `group_${k}`,
                });
                let m = {
                    groupName: k,
                    indicatorList: index_standards ? index_standards : [],
                    pageData: index_standards ? index_standards.slice(0, 10) : [],
                    // currentPage: 1,
                    // pageSize: 10,
                    total: index_standards ? index_standards.length : 0,
                    pageOption: setPageOption(index_standards, 10)
                }
                index_standards_list[`group_${k}`] = m
                pageNation.value[`group_${k}`] = {
                    currentPage: 1,
                    pageSize: 10,
                }
                // 第二级
                if (children.length) {
                    for (let kk in children) {
                        const { children: children1, group_name: group_name1, group_name_en: group_name_en1 } = children[kk]
                        // groupList2.value.push(group_name1);
                        groupList2.value.push({
                            name: i18n.global.locale == 'en' ? group_name_en1 : group_name1,
                            id: `group_${k}_${kk}`
                        });
                        let m = {
                            groupName: k,
                            indicatorList: children[kk].index_standards ? children[kk].index_standards : [],
                            pageData: children[kk].index_standards ? children[kk].index_standards.slice(0, 10) : [],
                            // currentPage: 1,
                            // pageSize: 10,
                            total: children[kk].index_standards ? children[kk].index_standards.length : 0,
                            pageOption: setPageOption(children[kk].index_standards, 10)
                        }
                        // index_standards_list.push(m)
                        index_standards_list[`group_${k}_${kk}`] = m
                        // pageNation.value.push({
                        //     id: `group2_${kk}`,
                        //     currentPage: 1,
                        //     pageSize: 10,
                        // })
                        pageNation.value[`group_${k}_${kk}`] = {
                            currentPage: 1,
                            pageSize: 10,
                        }
                        // 第三级
                        if (children1.length) {
                            // let groupList_3 = [...new Set(children1.map(item => item.group_name))];
                            for (const item3 in children1) {
                                // console.log(item3);
                                const { group_name: group_name2, group_name_en: group_name_en2, index_standards: index_standards2 } = children1[item3]
                                groupList3.value.push({
                                    name: i18n.global.locale == 'en' ? group_name_en2 : group_name2,
                                    id: `group_${k}_${kk}_${item3}`
                                });
                                // let index_standards_list3 = children1.filter(item => item.group_name === groupList_3[item3])
                                let m = {
                                    groupName: item3,
                                    indicatorList: index_standards2 ? index_standards2 : [],
                                    pageData: index_standards2 ? index_standards2.slice(0, 10) : [],
                                    // currentPage: 1,
                                    // pageSize: 10,
                                    total: index_standards2 ? index_standards2.length : 0,
                                    pageOption: setPageOption(index_standards2, 10)
                                }
                                // index_standards_list.push(m)
                                index_standards_list[`group_${k}_${kk}_${item3}`] = m
                                // pageNation.value.push({
                                //     id: `group3_${item3}`,
                                //     currentPage: 1,
                                //     pageSize: 10,
                                // })
                                pageNation.value[`group_${k}_${kk}_${item3}`] = {
                                    currentPage: 1,
                                    pageSize: 10,
                                }
                            }
                        }
                    }

                }
            }
        }
        selectedObj.value.create_time = resp.payload.create_time;
        selectedObj.value.update_time = resp.payload.update_time;
        selectedObj.value.index_standards = index_standards_list;
        // console.log(selectedObj.value.index_standards[current_tab.value]);
        current_tab.value = groupList1.value.length ? `group_0` : ''
        current_tab1.value = groupList1.value.length ? `group_0` : ''
        pageData.value = Object.keys(selectedObj.value.index_standards).length ? selectedObj.value.index_standards[current_tab.value].pageData : [];
        // console.log(selectedObj.value);
        groupList.value = {
            groupList1: groupList1.value,
            groupList2: groupList2.value,
            groupList3: groupList3.value
        }
        changTab()
    } else {
        if (resp.code == 1) {
            //为1 说明改数据不存在
            // handleNodeClick(treeData.value[0].id);
        } else {
            //其他错误  数据没有查询到详情
            selectedObj.value.id = id;
            openAlert({
                variant: "info",
                content: getLangValue("base.noDetailedInfo"),
            });
        }
    }
}
// const searchHsCode = async () => {
//     // showindex 不同操作不同
//     currentPage2.value = 1;
//     showIndex.value == 0 ? chartRefs.value.initCharts(search.name) : getTreeList();
// }

const getTreeList = async () => {
    // 获取tree信息
    loadingTree.value = true
    treeData.value = []
    const resp = await getHscode();
    if (resp) {
        treeData.value = [...resp.payload]
        treeData.value.forEach((tree) => {
            tree.num = 1;
            if (tree.children && tree.children.length) {
                tree.children = setValue(tree.children, tree.num);
            }
        });
        filterTreeData.value = [...treeData.value]
        // 获取id
        if (route.query.id) {
            // 如果路由有id 则获取该id的详情信息 以及他的父id 来展开tree列表
            // 获取父级id
            let arr = []
            findParent(resp.payload, route.query.id, arr)
            fatherIdList.value = [...arr]
            // console.log(fatherIdList.value)
            handleNodeClick(route.query.id);
        } else {
            if (treeData.value.length)
                handleNodeClick(treeData.value[0].id);
        }
        //制造图表数据
        if (treeData.value.length) {
            type.value = type.value == '' ? treeData.value[0].id : type.value;
            // type.value = '6653dca35a60581445cba03e';
            nextTick(() => {
                changeType();
            })
        }
        loadingTree.value = false
    }
}
// const getTreeList1 = async () => {
//     // 获取tree信息
//     treeData1.value = []
//     const resp = await getHscode({type:0});
//     if (resp) {
//         treeData1.value = [...resp.payload]
//         treeData1.value.forEach((tree) => {
//             tree.num = 1;
//             if (tree.children && tree.children.length) {
//                 tree.children = setValue(tree.children, tree.num);
//             }
//         });
//         //制造图表数据
//         if (treeData1.value.length) {
//             type.value = type.value == '' ? treeData1.value[0].id : type.value;
//             // type.value = '6653dca35a60581445cba03e';
//             nextTick(() => {
//                 changeType();
//             })
//         }
//     }
// }

const editHsCode = () => {
    // 编辑详情  如果是系统默认的顶级信息（服装、纱线...） 不能编辑
    // let titleList = treeData.value.map(item => item.title)
    // const titleList = i18n.global.locale == 'ch' ? ["服装", "织物", "纱线", "纤维", "床上用品", "普通家用纺织品", "产业纺织品", "厨卫用品"] :
    //     ["Garment", "Fabric", "Yarn", "Fiber", "Bedding", "Household Textiles", "Industrial Textiles", "Kitchen and Bathroom Supplies"];
    // if (titleList.includes(selectedObj.value.title)) {
    //     openAlert({
    //         variant: "info",
    //         content: getLangValue("base.cannotEdit"),
    //     });
    //     return
    // }
    let url = router.resolve({ path: '/hscode_management_detail', query: { type: 'edit', id: selectedObj.value.id, showIndex: showIndex.value }, }).href
    window.open(url, '_blank')
}
const changeType = () => {
    let arr = treeData.value.filter(item => item.id === type.value)
    //第一种  超过100只获取2级 
    // let data ={}
    // let data1 = treeToFlat(arr, 'parentId')
    // const { nodeData, links } =data1
    // if (nodeData.length > 100 || links.length > 100){
    //     data = treeToFlat1(arr, 'parentId')
    // }else {
    //     data = data1
    // }

    //第二种全部显示
    const data = treeToFlat(arr, 'parentId')
    chartRefs.value.initCharts(data)
}

const updateChartData = (id) => {
    // 更新图表
    let arr = getId(treeData.value, id);
    const { nodeData, links: newLinks } = treeToFlat1(arr, 'parentId')
    // console.log(nodeData);
    // console.log(newLinks);
    nodeData.shift()
    let nodes = chartRefs.value.myChart.getOption().series[0].data;
    nodes = [...nodeData, ...nodes]
    let links = chartRefs.value.myChart.getOption().series[0].links;
    links = [...newLinks, ...links]
    chartRefs.value.myChart.setOption({
        series: [{
            data: nodes,
            links: links
        }]
    });
}

const deleteHsCode = () => {
    //删除
    Swal.fire({
        title: getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? selectedObj.value.title + '?' : ''}`,
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            //获取该code的子集 如果包含子集就不能删除
            let arr = getId(treeData.value, selectedObj.value.id);
            // console.log(selectedObj.value.id);
            // console.log(arr);
            if (arr.length && arr[0].children.length) {
                // console.log(`该code下包含${arr[0].children.length}个子集`);
                openAlert({
                    variant: "info",
                    content: getLangValue("base.delete_alert_hscode_info"),
                });
            } else {
                //延迟2s操作
                let resp = await deleteHscode(selectedObj.value.id);
                if (resp) {
                    openAlert({
                        variant: resp.code == 1 ? "danger" : 'success',
                        content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                    });
                    if (resp.code == 0)
                        getTreeList();
                }

            }
        }
    });
}

const copyHsCode = async () => {
    // 复制
    Swal.fire({
        title: getLangValue("base.copying"),
        // timer: 2000,
        timerProgressBar: true,
        didOpen: async () => {
            Swal.showLoading();
            let xx = true
            if (xx) {
                const resp = await copyHscode(selectedObj.value.id);
                if (resp.code == 1) {
                    openAlert({
                        variant: "danger",
                        content: resp.message,
                    });
                    Swal.close()
                    return false
                }
                openAlert({
                    variant: "success",
                    content: getLangValue("base.copy_success"),
                });
                Swal.close()
                // 刷新页面
                await getTreeList();
            }
        },
        willClose: () => {
            // clearInterval(timerInterval);
        }
    }).then(async () => {
        /* Read more about handling dismissals below */

    });


}

const onActiveTabId = (id) => {
    current_tab.value = id;
}

// watch(current_tab1, (val) => {
//     current_tab.value = val
//     current_tab2.value = ''
//     current_tab3.value = ''
// })
// watch(current_tab2, (val) => {
//     current_tab.value = val
//     current_tab3.value = ''
// })
// watch(current_tab3, (val) => {
//     current_tab.value = val
// })

const sortTree = async (treeData) => {
    // 排序
    let newTree = treeData.map((item, index) => {
        return {
            index,
            id: item.id
        }
    })
    console.log(newTree);
    if (newTree.length) {
        const resp = await postHscode_management_index({ hscode_list: newTree });
        if (resp.code == 0) {
            // 更新tree
            getTreeList();
        } else {
            openAlert({
                variant: "danger",
                content: resp.message,
            });
        }
    }

}
provide('sortTree', sortTree) // 提供排序方法给子组件

onMounted(() => {
    // 设置选中数据
    // selectedObj.value = treeData.value[0];
    // 根据url showIndex切换
    showIndex.value = router.currentRoute.value.query.showIndex ? router.currentRoute.value.query.showIndex : 1;
    //获取信息
    getTreeList();
    // getTreeList1()
})
</script>

<style lang="scss" scoped>
:deep(.el-select__wrapper) {
    height: 100%;
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.8125rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.8125rem;
    color: #212529;
}

.hscode {
    height: calc(100vh - 220px);
    // min-width: 1200px;
    width: 100%;

    .hscode-container {
        display: flex;
        height: 100%;
        // overflow-y: auto;

        .tree-content {
            flex: 2;
            margin: 0 10px;
            // height: 696px;
            // height: 100%;
            min-height: 400px;
            max-height: 100%;

            .leftMenu {
                width: 400px;
                margin-bottom: 0;
                height: 100%;

                .menu-head {
                    padding: 15px 0px 15px 20px;
                    font-size: 16px;
                }
            }
        }

        .hscode-content {
            flex: 8;
            align-items: center;
            max-height: 100%;
            width: calc(100% - 400px);
            min-width: 835px;

            .basic-info {
                margin: 10px 0;

            }

            .title {
                font-weight: bold;
                font-size: 22px;

                .el-tag {
                    font-weight: bold;
                    font-size: 22px;
                }
            }

            .group-tabs {
                // height: calc(100% - 299.5px);
                height: calc(100% - 275.5px - 0.5rem);

                .nav-success.nav-tabs-custom .nav-link {
                    color: #212529;
                    font-size: 13px;
                    font-weight: 400;
                }

                .nav-success.nav-tabs-custom .nav-link.active::after {
                    background-color: #6691E7;
                }
            }

        }
    }
}
</style>